module.exports = __webpack_public_path__ + "img/oremi.2d6ea14c.jpg";